/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import * as color from '@constant/color';
import * as size from '@constant/size';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import IconBlock from '@component/common/block/icon-block';
import Gap from '@component/common/gap';
import ToastBackground from '@component/common/toast-background';
import * as animation from '@constant/animation';

interface IProps {
  children: React.ReactNode;
  onClose?: () => void;
}

const Toast = styled.div`
  position: relative;
  background-color: ${color.WHITE_1};
  border-radius: ${size.BORDER_RADIUS_2} ${size.BORDER_RADIUS_2} 0 0;
  padding: ${size.TOAST_PADDING};
  width: ${IS_IYAGIGO_MOBILE_VIEW ? '100vw' : size.ISLAND_WIDTH};
  display: flex;
  flex-flow: column nowrap;
  ${animation.TOAST_SLIDE_UP_CSS}
`;

const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30px;
`;

const CloseButtonContainer = styled.div`
  position: absolute;
  top: ${size.MARGIN_1};
  right: ${size.MARGIN_1};
  cursor: pointer;
`;

const ToastTemplate: React.FC<IProps> = ({ children, onClose }) => {
  const dispatch = useTypedDispatch();
  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }
    dispatch(modalActions.hideToast());
  };

  return (
    <ToastBackground onClick={handleClose}>
      <Toast>
        <Header>
          <CloseButtonContainer>
            <IconBlock
              icon='close'
              design={{
                icon: { size: 'medium', kind: 'outlined' },
                box: { event: { cursor: 'pointer' } },
              }}
              click={{ handler: handleClose }}
            />
          </CloseButtonContainer>
        </Header>
        <Gap height={size.MARGIN_1} />
        {children}
      </Toast>
    </ToastBackground>
  );
};

export default ToastTemplate;
